import React from "react";

import { Progress } from "@chakra-ui/react";

import useStore from "../../../store";

const ReportProgress = () => {
  const currentStep = useStore((state) => state.report.currentStep);
  const viewedReportState = useStore((state) => state.report.viewedReportState);
  const progress = useStore((state) => state.report.progress);

  // If the viewer isn't editing the report or is beeing welcomed don't show the progress
  if (viewedReportState[0] === null) return null;
  if (viewedReportState[1] === "view" || currentStep === "welcome") return null;

  return (
    <Progress
      display={["none", "block"]}
      width={[0, 280, 320]}
      rounded="md"
      value={progress}
      max={100}
    />
  );
};

export default ReportProgress;
